/**
 * Page View Value Object
 * Represents a page view event in the application
 */
export class PageView {
    private constructor(
        public readonly path: string,
        public readonly title: string,
        public readonly location?: string,
        public readonly metadata?: Record<string, any>
    ) { }

    static create(params: {
        path: string;
        title: string;
        location?: string;
        metadata?: Record<string, any>;
    }): PageView {
        if (!params.path || params.path.trim() === '') {
            throw new Error('Page path is required');
        }
        if (!params.title || params.title.trim() === '') {
            throw new Error('Page title is required');
        }

        return new PageView(
            params.path,
            params.title,
            params.location,
            params.metadata
        );
    }

    /**
     * Convert to plain object for tracking
     */
    toTrackingData(): {
        page_path: string;
        page_title: string;
        page_location?: string;
        [key: string]: any;
    } {
        return {
            page_path: this.path,
            page_title: this.title,
            ...(this.location && { page_location: this.location }),
            ...(this.metadata && this.metadata),
        };
    }
}
